"use strict";Object.defineProperty(exports, "__esModule", {value: true});const COUNTER_THRESHOLD = 0.8

// The length counter shows once the draft reaches 80% of the limit.
 const lengthCounter = (length, maxLength) => {
  if (!maxLength || length < Math.ceil(maxLength * COUNTER_THRESHOLD)) return null
  return { text: `${length} / ${maxLength}`, label: `${length} of ${maxLength} characters` }
}; exports.lengthCounter = lengthCounter
